import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class VopdApi {
  private readonly apiController: string = 'Vopd';

  constructor(private api: HttpService) { }

  list<returnType>(url: string,queryparams?:HttpParams): Observable<returnType> {
    if(!!queryparams){
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
    }
    else{
      let header = new HttpHeaders();
     header.append('Content-Type', 'applications/json');
     header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    }
   
  }

  getById<type>(url : string,queryparams?:HttpParams): Observable<type> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
  }
    
  add<type,returnType>(url:string, data:type,queryparams?:HttpParams):Observable<returnType>{
    if(!!queryparams){
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.post( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
    }
    else{
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.post( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    }
   
  }

  update<type,returnType>(url:string, data:type,queryparams?:HttpParams):Observable<returnType>{
    if(!!queryparams){
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});    
    }
    else{
      let header = new HttpHeaders();
      header.append('Content-Type', 'applications/json');
      header.append('Accept','application/vnd.ezovion.hateoas+json');
      return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
    }
    
  }

  

  

}
